import {createContext, type Dispatch} from 'react'
import {type AllActions} from './state/actions'
import {type IncidentsWidgetState} from './types/incidents-widget-state'
import {DEFAULT_INCIDENTS_WIDGET_STATE} from './types/default-incidents-widget-state'

export const IncidentsWidgetContext = createContext<{
    state: IncidentsWidgetState
    dispatch: Dispatch<AllActions> | undefined
}>({state: DEFAULT_INCIDENTS_WIDGET_STATE, dispatch: undefined})
